<template>
  <div>
    <b-card>
      <b-card-title class="mb-25">
        {{ itemData.title }}
      </b-card-title>
      <b-card-sub-title class="mb-2">
        {{ itemData.route }} — boş bırakılan alanlar sayfa içeriğinden otomatik üretilir.
      </b-card-sub-title>
      <b-form-group
        label="Meta Başlık"
        label-for="meta_title"
      >
        <b-form-input
          id="meta_title"
          v-model="itemData.meta_title"
          placeholder="Boş bırakılırsa sayfa başlığı kullanılır"
        />
        <div class="text-muted mt-1">
          Başlık Uzunluğu: {{ itemData.meta_title? itemData.meta_title.length : 0 }} / 60
          <div class="font-small-2 text-info">
            Önerilen Uzunluk: 60 karakter. Tarayıcı sekmesinde ve arama sonucunda yazdığınız şekliyle görünür.
          </div>
        </div>
      </b-form-group>
      <b-form-group
        label="Meta Açıklama"
        label-for="meta_desc"
      >
        <b-form-textarea
          id="meta_desc"
          v-model="itemData.meta_desc"
          placeholder="Boş bırakılırsa sayfa metninden üretilir"
          rows="3"
        />
        <div class="text-muted mt-1">
          Açıklama Uzunluğu: {{ itemData.meta_desc? itemData.meta_desc.length : 0 }} / 155
          <div class="font-small-2 text-info">
            Önerilen Uzunluk: 155 karakter
          </div>
        </div>
      </b-form-group>
      <b-form-group
        label="Anahtar Kelimeler"
        label-for="meta_keywords"
      >
        <b-form-textarea
          id="meta_keywords"
          v-model="itemData.meta_keywords"
          placeholder="Virgülle ayırın: cıvata, somun, soğuk dövme"
          rows="3"
        />
        <div class="text-muted mt-1">
          Anahtar Kelime: {{ itemData.meta_keywords? itemData.meta_keywords.length : 0 }} / 260
          <div class="font-small-2 text-info">
            Önerilen Uzunluk: 260 karakter
          </div>
        </div>
      </b-form-group>
    </b-card>
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle, BFormGroup, BFormInput, BFormTextarea, BButton,
} from 'bootstrap-vue'

export default {
  name: 'ComponentForm',
  components: {
    BCard,
    BCardTitle,
    BCardSubTitle,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['components/dataItem']
    },
  },
}
</script>
